import axios from 'axios'

class DashboardDataFactory {
  async paymentStatistic (data: any) {
    try {
      const url = '/dashboard/payment_statistic'
      const response = await axios.get(url, {
        params: {
          school_year_id: data.school_year_id,
          class_id: data.class_id,
          inactive: data.inactive,
          published: data.published
        }
      })
      return response.data
    } catch (error) {
      console.error(error)
      return false
    }
  }

  async recentPayment (data: any, limit: number, offset: number) {
    try {
      const url = '/dashboard/recent_payments'
      const response = await axios.get(url, {
        params: {
          school_year_id: data.school_year_id,
          class_id: data.class_id,
          inactive: data.inactive,
          published: data.published,
          limit: limit,
          offset: offset
        }
      })
      return response.data
    } catch (error) {
      console.error(error)
      return false
    }
  }

  async detailPayment (data: any, limit: number, offset: number, search: string) {
    try {
      const url = '/dashboard/detail_payment'
      const response = await axios.get(url, {
        params: {
          school_year_id: data.school_year_id,
          class_id: data.class_id,
          inactive: data.inactive,
          published: data.published,
          limit: limit,
          offset: offset,
          search: search
        }
      })
      return response.data
    } catch (error) {
      console.error(error)
      return false
    }
  }
}

export const dashboardDataFactory = new DashboardDataFactory()
